import { computed, makeObservable } from 'mobx';

import { UserProfile } from 'common/types/models/user';
import { AppController } from 'app/controllers';
import { Navigation } from 'app/services/navigation';
import { PremiumLevel } from 'common/types/models';
import { Routes } from 'src/types/routes';
import { FlagModel } from '@zajno/common-mobx/viewModels';

export class UserViewModel {
    private readonly _userId: string;
    private readonly _isLoading = new FlagModel(false);

    constructor(id: string) {
        this._userId = id;

        makeObservable(this, {
            user: computed,
        });
    }

    public get userId() { return this._userId; }
    public get user() { return AppController.Instance.Users.repo.getUserDeferred(this._userId).current; }
    public get email() { return UserProfile.getEmail(this.user); }
    public get name() { return UserProfile.getName(this.user); }

    public get isLoading() { return this._isLoading.value; }

    public changePremiumLevel = async (level: PremiumLevel) => {
        this._isLoading.setTrue();

        await AppController.Instance.Users.setPremiumLevel(this._userId, level);

        this._isLoading.setFalse();
    };

    public navigateToTheInnerPage = () => {
        Navigation.value.push(Routes.Dashboard.UserInnerPage(this._userId));
    };
}
